"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeIconButtonStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeIconButtonStyles = function makeIconButtonStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;

  var makeGetButtonStyles = function makeGetButtonStyles(_ref2) {
    var size = _ref2.size;
    // Overriding size tokens because we are reusing button tokens but the
    // vertical padding is slightly different
    var sizeOverrides = size === "dense" ? {
      paddingBottom: "5px",
      paddingTop: "5px"
    } : {
      paddingBottom: "7px",
      paddingTop: "7px"
    };
    return function (_ref3) {
      var fullWidth = _ref3.fullWidth,
          variant = _ref3.variant;
      var button = tokens.button;
      var widthOverrides = fullWidth ? {
        width: "100%"
      } : {
        minWidth: "auto",
        paddingLeft: primitives.spacings[3],
        paddingRight: primitives.spacings[3]
      };
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, button[variant][size].default), sizeOverrides), widthOverrides), {}, {
        "&:hover": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].hover), sizeOverrides), widthOverrides),
        "&.Mui-disabled": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].disabled), sizeOverrides), widthOverrides),
        "&:focus": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].focus), sizeOverrides), widthOverrides),
        "&:focus:active": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].pressed), sizeOverrides), widthOverrides),
        "&:active": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].pressed), sizeOverrides), widthOverrides)
      });
    };
  };

  var getSmallButtonStyles = makeGetButtonStyles({
    size: "dense"
  });
  var getMediumButtonStyles = makeGetButtonStyles({
    size: "defaultSize"
  });
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: primitives.borderRadii.medium,
          "& [class*='MuiSvgIcon-root']": {
            color: "inherit"
          },
          "&[class*='MuiIconButton-sizeSmall']": {
            "& [class*='MuiSvgIcon-root']": {
              fontSize: "20px"
            },
            "&.DhigIconButton--variant--contained": getSmallButtonStyles({
              variant: "contained"
            }),
            "&.DhigIconButton--variant--contained.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "contained"
            }),
            "&.DhigIconButton--variant--outlined": getSmallButtonStyles({
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--outlined.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--text": getSmallButtonStyles({
              variant: "text"
            }),
            "&.DhigIconButton--variant--text.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "text"
            })
          },
          "&[class*='MuiIconButton-sizeMedium']": {
            "& [class*='MuiSvgIcon-root']": {
              fontSize: "24px"
            },
            "&.DhigIconButton--variant--contained": getMediumButtonStyles({
              variant: "contained"
            }),
            "&.DhigIconButton--variant--contained.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "contained"
            }),
            "&.DhigIconButton--variant--outlined": getMediumButtonStyles({
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--outlined.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--text": getMediumButtonStyles({
              variant: "text"
            }),
            "&.DhigIconButton--variant--text.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "text"
            })
          }
        }
      }
    }
  };
};

exports.makeIconButtonStyles = makeIconButtonStyles;